import React, { useEffect, useState } from 'react'
import './home.css'
import { useDispatch, useSelector } from 'react-redux'
import { handleStaffs } from '../../state/userSlice'
import { getAllUsers, } from '../../api'
// import {io} from 'socket.io-client'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment'
import ClockIn from '../../components/clockIn/ClockIn'
import Team from '../../components/team/Team'
import Activities from '../../components/activities/Activities'
import TotalStaff from '../../components/hr/totalStaff/TotalStaff'
import PayrollChart from '../../components/barCharts/payrollChart'
import AbsentCard from '../../components/hr/absentCard/AbsentCard'
import TaskCard from '../../components/taskCard/TaskCard'
import ReportsCard from '../../components/reportsCard/ReportsCard'
import LeaveCard from '../../components/leaveCard/LeaveCard'
import StaffTable from '../../components/dataTables/StaffTable'
import { Link } from 'react-router-dom'



const Home = ({socket}) => {
  const {user, staffs} = useSelector((state)=> state.user)
  const dispatch = useDispatch()

  // useEffect(()=>{
  //   socket.emit('new-user', user?._id)
  //   socket.on('get-users', (socketUsers)=>{
  //       // console.log('This are the connected users', socketUsers)
  //   })
  // },[])

  const handleFetchUsers = async () => {
    try{
        const res = await getAllUsers(user?.token)
        dispatch(handleStaffs(res?.data))
    }catch(error){
        console.log(error)
    }
  }

  const today = new Date()
  const twoMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 2, today.getDate());

  const staffsTwoMonthsAgo = staffs?.filter((item) => {
      const createdAtDate = new Date(item?.createdAt);
      return createdAtDate >= twoMonthsAgo && createdAtDate < today;
  });

  const staffsTwoMonthsAgoLength = staffsTwoMonthsAgo?.length;

  const teams = staffs?.filter((item)=>{
    return item?.department === user?.department
  })


  const totalAttendance = user?.attendance?.filter((item)=>{
    const currentMonth = today.toLocaleString('en-US', {month: 'long'})
    const currentYear = today.getFullYear()
    return currentMonth === item?.month  && String(currentYear) === item?.year
  })

  const currentMonth = today.getMonth() + 1
  const currentYear = today.getFullYear()

  const filterTodolist = user?.todolist?.filter((item)=> {
    return String(item?.month) === String(currentMonth) && String(item?.year) === String(currentYear)
  })
  const filterReport = user?.reports?.filter((item)=> {
    return String(item?.month) === String(currentMonth) && String(item?.year) === String(currentYear)
  })

  useEffect(()=>{
      handleFetchUsers()
  },[])

  useEffect(() => {
    // Check if Notification API is supported by the browser
    if ('Notification' in window) {
      // Check notification permission
      if (Notification.permission !== 'granted') {
        Notification.requestPermission();
      }
    }
  }, []);

  
  return (
    <section className="home">
      <ToastContainer/>

      <div className="heading">
        <div className="heading-item">
          <h3 className="heading-title">Dashboard | </h3>
          <i class='bx bx-home heading__title-icon'></i>
          <span className="heading-text">
            Home <i class='bx bx-chevron-right heading-icon'></i>
          </span>
        </div>
          <p className="heading-text">Welcome back! 
            <span className="heading-name">{user?.firstName}</span>
          </p>
      </div>

      {/* DASHBOARD CARD */}
      <div className="home__dashboard"
      style={{gridTemplateColumns: user.department === 'HR' || user.role === 'Administrator' ?
      'repeat(auto-fit, minmax(200px, 1fr))'
      :'repeat(auto-fit, minmax(300px, 1fr))'}}>

      {/* ATTENDANCE */}
        <div className="home__dashboard-box">
          <div className="home__dashboard-box_top">
            <div className="home__dashboard-icon">
              <i class='bx bxs-user-account'></i>
            </div>
            <div className="home__dashboard-text">
              <h2 className="home__dashboard-title">Attendance</h2>
              <span className="home__dashboard-count">
                {totalAttendance?.map((item)=>item?.totalMarkedDays)}
              </span>
            </div>
          </div>
          <div className="home__dashboard-box_bottom">
            <span className="home__dashboard-box_missed">Absent this month:</span>
            <span className="home__dashboard-box_count">
              {totalAttendance?.map((item)=>item?.totalNotMarkedDays)}
            </span>
          </div>
        </div>

      {/* TODO LIST */}
        <div className="home__dashboard-box">
          <div className="home__dashboard-box_top">
            <div className="home__dashboard-icon">
              <i class='bx bxs-notepad'></i>
            </div>
            <div className="home__dashboard-text">
              <h2 className="home__dashboard-title">Todo-List</h2>
              <span className="home__dashboard-count">
                {filterTodolist?.map((item)=>item?.totalMarkedDays) || 0}
              </span>
            </div>
          </div>
          <div className="home__dashboard-box_bottom">
            <span className="home__dashboard-box_missed">Missed this month:</span>
            <span className="home__dashboard-box_count">
              {filterTodolist?.map((item)=>item?.totalNotMarkedDays) || 0}
            </span>
          </div>
        </div>

      {/* REPORTS */}
        <div className="home__dashboard-box">
          <div className="home__dashboard-box_top">
            <div className="home__dashboard-icon">
              <i class='bx bxs-report'></i>
            </div>
            <div className="home__dashboard-text">
              <h2 className="home__dashboard-title">Reports</h2>
              <span className="home__dashboard-count">
                {filterReport?.map((item)=>item?.totalSubmitted) || 0}
              </span>
            </div>
          </div>
          <div className="home__dashboard-box_bottom">
            <span className="home__dashboard-box_missed">Missed this month:</span>
            <span className="home__dashboard-box_count">
              {filterReport?.map((item)=>item?.totalMissed) || 0}  
            </span>
          </div>
        </div>

        {/* HR */}
        {
          user?.department === 'HR' || user?.role === 'Administrator' ?
          <div className="home__dashboard-box">
            <div className="home__dashboard-box_top">
              <div className="home__dashboard-icon">
                <i class='bx bx-user'></i>
              </div>
              <div className="home__dashboard-text">
                <h2 className="home__dashboard-title">Total Employees</h2>
                <span className="home__dashboard-count">{staffs?.length}</span>
              </div>
            </div>
            <div className="home__dashboard-box_bottom">
              <span className="home__dashboard-box_missed">New:</span>
              <span className="home__dashboard-box_count">{staffsTwoMonthsAgoLength}</span>
            </div>
          </div> : ''
        }
      </div>

      {/*  Activity Feed */}
      {
      user?.department === 'HR' || user?.role === 'Administrator' ? ( 
        <>
          <div className="home__content-chart">
            <TotalStaff/>
            <PayrollChart/>
          </div> 
          <div className="home__content-overview">
            <ClockIn/>
            <AbsentCard/>
            <Activities/>
          </div>
          <div className='home__content-table'>
            <div className="home__content-table_heading">
              <h4 className="home__content-table_title">Employees</h4>
              <Link to={'/employees'} 
              className='home__content-table_link'>View all</Link>
            </div>
            <StaffTable staffs={staffs} user={user}/>
          </div>
        </>
      ) : (
        <div className="home__content-overview">
          <ClockIn/>
          <Team teams={teams} user={user}/>
          <Activities/>
          <TaskCard/>
          <ReportsCard/>
          <LeaveCard/>
        </div>
      )
      }
      
    </section>
  )
}

export default Home